export default __webpack_public_path__ + "static/media/050-wear face mask.814afaa9.svg";